export default __webpack_public_path__ + "i18n/translations/translation-cs.7f7acf37.json";